import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../Apis/apiConfig";
import { ArrowLeft, Plus, Trash2, Save, Columns, Database, CheckCircle, AlertCircle, ChevronRight, RefreshCw, } from "lucide-react";
import { useNavigate } from "react-router-dom";

const DEFAULT_HEADERS = ["BILL NO", "BILL DATE", "DUE DATE", "UNIT NO", "Bill For", "MEMBER NAME",
  "Total Amount", "Area Sqr Ft"];

const DynamicForm = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [fields, setFields] = useState([[...DEFAULT_HEADERS]]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // const handleChange = (rowIndex, colIndex, value) => {
  //   const newFields = [...fields];
  //   newFields[rowIndex][colIndex] = value;
  //   setFields(newFields);
  // };

//   const handleChange = (rowIndex, colIndex, value) => {
//   // Allow only letters, numbers and spaces
//   let sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

//   // Replace spaces with underscore
//   sanitizedValue = sanitizedValue.replace(/\s+/g, "_");

//   const newFields = [...fields];
//   newFields[rowIndex][colIndex] = sanitizedValue;
//   setFields(newFields);
// };

const handleChange = (rowIndex, colIndex, value) => {
  const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

  const newFields = [...fields];
  newFields[rowIndex][colIndex] = sanitizedValue;
  setFields(newFields);
};

  const handleAddRow = () => {
    setFields([...fields, [""]]);
  };

  const handleRemoveRow = (rowIndex) => {
    if (fields.length === 1) return;
    setFields(fields.filter((_, i) => i !== rowIndex));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const allHeaders = fields
      .flat()
      .map((f) => f.trim())
      .filter(Boolean)
      .map((h) => h.toUpperCase());

    const defaultHeaders = DEFAULT_HEADERS.map((h) => h.toUpperCase());

    const hasNewHeader = allHeaders.some((h) => !defaultHeaders.includes(h));

    if (!hasNewHeader) {
      toast.error("Please add at least one new column before saving.");
      setIsSubmitting(false);
      return;
    }

    const headers = [...new Set(allHeaders)];

    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");

    if (!token || !societyName) {
      toast.error("Authentication error");
      setIsSubmitting(false);
      return;
    }

    try {
      await fetch(
        `${BASE_URL}/dynamic-table/add-headers?societyName=${encodeURIComponent(
          societyName,
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(headers),
        },
      );
      toast.success("Bill table headers created successfully!");
      setTimeout(() => {
        navigate("/upload-menu");
      }, 1500);
    } catch {
      toast.error("Server error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAddColumn = (rowIndex) => {
    const newFields = [...fields];
    newFields[rowIndex].push("");
    setFields(newFields);
  };

  const handleRemoveColumn = (rowIndex, colIndex) => {
    if (rowIndex === 0 && colIndex < DEFAULT_HEADERS.length) {
      toast.error("Cannot remove default headers");
      return;
    }
    const newFields = [...fields];
    newFields[rowIndex].splice(colIndex, 1);
    setFields(newFields);
  };

  return (
    <div className="app-container">
      <style>
        {`
        .app-container {
          height: 100vh;
          overflow: hidden;
        }

        .main-layout {
          height: calc(100vh - 64px);
          overflow: hidden;
        }

        .content-area {
          height: 100%;
          overflow-y: auto;
          padding-bottom: 120px;
          background: #f8fafc;
        }

        .dynamic-form-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 24px;
        }

        .back-button-container {
          margin-bottom: 24px;
        }

        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          color: #475569;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          text-decoration: none;
        }

        .back-button:hover {
          background: #f8fafc;
          border-color: #cbd5e0;
          transform: translateX(-2px);
        }

        /* Header Section */
        .form-header-section {
          background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
          padding: 24px 32px;
          border-radius: 16px;
          color: white;
          margin-bottom: 32px;
          position: relative;
          overflow: hidden;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 20px;
          position: relative;
          z-index: 2;
        }

        .header-icon {
          background: rgba(255, 255, 255, 0.2);
          width: 64px;
          height: 64px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
        }

        .header-text h1 {
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 8px 0;
        }

        .header-text p {
          font-size: 14px;
          opacity: 0.9;
          margin: 0;
          max-width: 600px;
        }

        .header-stats {
          display: flex;
          gap: 32px;
          margin-top: 20px;
          flex-wrap: wrap;
        }

        .stat-item {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .stat-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .stat-text {
          display: flex;
          flex-direction: column;
        }

        .stat-number {
          font-size: 20px;
          font-weight: 700;
          line-height: 1;
        }

        .stat-label {
          font-size: 12px;
          opacity: 0.8;
          margin-top: 4px;
        }

        /* Form Card */
        .form-card {
          background: white;
          border-radius: 16px;
          padding: 32px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          margin-bottom: 32px;
        }

        .form-title {
          font-size: 24px;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 16px 0;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .form-description {
          font-size: 14px;
          color: #64748b;
          margin: 0 0 32px 0;
          line-height: 1.6;
        }

        /* Fields Grid */
        .fields-container {
          margin-bottom: 32px;
        }

        .field-row {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 16px;
          align-items: center;
          padding: 16px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
        }

        .field-input {
          flex: 1;
          min-width: 180px;
          padding: 12px 16px;
          border-radius: 8px;
          border: 2px solid #e2e8f0;
          font-size: 14px;
          color: #1e293b;
          transition: all 0.2s;
          background: white;
        }

        .field-input:focus {
          outline: none;
          border-color: #0d6efd;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
        }

        .field-input.default {
          background: #f0f9ff;
          border-color: #bae6fd;
          font-weight: 600;
          color: #0369a1;
        }

        .field-input.default:focus {
          border-color: #0d6efd;
        }

        .field-actions {
          display: flex;
          gap: 8px;
        }

        .icon-btn {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          color: #64748b;
        }

        .icon-btn:hover {
          background: #f1f5f9;
          color: #475569;
        }

        .icon-btn.add {
          background: #10b981;
          border-color: #10b981;
          color: white;
        }

        .icon-btn.add:hover {
          background: #059669;
        }

        .icon-btn.remove {
          background: #fee2e2;
          border-color: #fecaca;
          color: #dc2626;
        }

        .icon-btn.remove:hover {
          background: #fecaca;
        }

        /* Row Actions */
        .row-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .row-label {
          font-size: 14px;
          font-weight: 600;
          color: #475569;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        /* Submit Button */
        .submit-button {
          width: 100%;
          padding: 16px;
          background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }

        .submit-button:hover {
          opacity: 0.9;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(13, 110, 253, 0.25);
        }

        .submit-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Instructions */
        .instructions {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 24px;
          margin-top: 32px;
        }

        .instructions-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .instructions-icon {
          color: #0d6efd;
        }

        .instructions h3 {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }

        .instructions-list {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 16px;
        }

        .instruction {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px;
          background: white;
          border-radius: 10px;
          border: 1px solid #e2e8f0;
        }

        .instruction-number {
          width: 24px;
          height: 24px;
          border-radius: 6px;
          background: #0d6efd;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 600;
          flex-shrink: 0;
        }

        .instruction-text {
          font-size: 14px;
          color: #475569;
          line-height: 1.5;
        }

        /* Loading Overlay */
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          backdrop-filter: blur(4px);
        }

        .loading-content {
          text-align: center;
          background: white;
          padding: 40px;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid #e2e8f0;
        }

        .spin-animation {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .dynamic-form-container {
            padding: 16px;
          }
          
          .form-header-section {
            padding: 20px;
          }
          
          .header-content {
            flex-direction: column;
            text-align: center;
            gap: 16px;
          }
          
          .header-stats {
            gap: 16px;
          }
          
          .stat-item {
            flex: 1;
            min-width: 140px;
          }
          
          .field-input {
            min-width: 100%;
          }
        }

        @media (max-width: 480px) {
          .form-card {
            padding: 20px;
          }
          
          .icon-btn {
            width: 36px;
            height: 36px;
          }
          
          .instructions-list {
            grid-template-columns: 1fr;
          }
        }
        `}
      </style>

      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div className="dynamic-form-container">
            {/* Form Card */}
            <div className="form-card">
              <h2 className="form-title">
                <Columns size={24} />
                Define Table Headers
              </h2>
              <p className="form-description">
                Default headers are pre-filled. Click the + button to add new
                rows or columns. Add at least one new column before saving.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="fields-container">
                  {fields.map((row, rowIndex) => (
                    <div key={rowIndex} className="field-row">
                      <div className="row-header">
                        <div className="row-label">
                          {rowIndex === 0 ? (
                            <>
                              <AlertCircle size={16} color="#0d6efd" />
                              Default Headers
                            </>
                          ) : (
                            <>
                              <Plus size={16} color="#10b981" />
                              Row {rowIndex + 1}
                            </>
                          )}
                        </div>
                        {rowIndex > 0 && (
                          <button
                            type="button"
                            onClick={() => handleRemoveRow(rowIndex)}
                            className="icon-btn remove"
                            title="Remove this row"
                          >
                            <Trash2 size={16} />
                          </button>
                        )}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        {row.map((field, colIndex) => (
                          <div
                            key={colIndex}
                            style={{
                              position: "relative",
                              flex: "1",
                              minWidth: "180px",
                            }}
                          >
                            <input
                              type="text"
                              value={field}
                              onChange={(e) =>
                                handleChange(rowIndex, colIndex, e.target.value)
                              }
                              placeholder={
                                rowIndex === 0 ? "Default header" : "New header"
                              }
                              className={`field-input ${rowIndex === 0 && colIndex < DEFAULT_HEADERS.length ? "default" : ""}`}
                            />
                            {rowIndex === 0 &&
                            colIndex < DEFAULT_HEADERS.length ? (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "12px",
                                  color: "#0d6efd",
                                  fontWeight: 600,
                                }}
                              >
                                ✓
                              </div>
                            ) : (
                              <button
                                type="button"
                                onClick={() =>
                                  handleRemoveColumn(rowIndex, colIndex)
                                }
                                style={{
                                  position: "absolute",
                                  right: "8px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  background: "none",
                                  border: "none",
                                  color: "#dc2626",
                                  cursor: "pointer",
                                  fontSize: "18px",
                                  padding: "0",
                                  lineHeight: "1",
                                }}
                                title="Remove this column"
                              >
                                ×
                              </button>
                            )}
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={() => handleAddColumn(rowIndex)}
                          className="icon-btn add"
                          title="Add new column"
                        >
                          <Plus size={16} />
                        </button>
                      </div>
                    </div>
                  ))}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "16px",
                    }}
                  >
                  </div>
                </div>

                <button
                  type="submit"
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <div className="spin-animation">
                        <RefreshCw size={20} />
                      </div>
                      Creating Table...
                    </>
                  ) : (
                    <>
                      <Save size={20} />
                      Create Bill Table
                      <ChevronRight size={20} />
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Instructions */}
            <div className="instructions">
              <div className="instructions-header">
                <AlertCircle size={24} className="instructions-icon" />
                <h3>How to Create Your Bill Table</h3>
              </div>
              <div className="instructions-list">
                <div className="instruction">
                  <div className="instruction-number">1</div>
                  <div className="instruction-text">
                    Default headers are pre-filled and cannot be removed
                  </div>
                </div>
                <div className="instruction">
                  <div className="instruction-number">2</div>
                  <div className="instruction-text">
                    Add custom columns for specific charges, fees, or data
                  </div>
                </div>
                <div className="instruction">
                  <div className="instruction-number">3</div>
                  <div className="instruction-text">
                    Click "+ Add New Row" to create multiple header rows
                  </div>
                </div>
                <div className="instruction">
                  <div className="instruction-number">4</div>
                  <div className="instruction-text">
                    Save your table structure to use in bill uploads
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Loading Overlay */}
          {isSubmitting && (
            <div className="loading-overlay">
              <div className="loading-content">
                <RefreshCw
                  size={48}
                  className="spin-animation"
                  color="#0d6efd"
                />
                <h3 style={{ marginTop: "20px", color: "#1e293b" }}>
                  Creating Bill Table...
                </h3>
                <p style={{ color: "#64748b", marginTop: "8px" }}>
                  Please wait while we save your table structure
                </p>
              </div>
            </div>
          )}

          <ToastContainer />
        </main>
      </div>
    </div>
  );
};

export default DynamicForm;
